import React, { useState } from 'react';
import PropTypes from 'prop-types';

import I18n from 'utils/I18n';
import Modal, { ModalActions, ModalBody, ModalTitle } from '@strava/ui/Modal';
import Button from '@strava/ui/Button';

import { Markup } from 'interweave';
import styles from './EmbedModal.scss';

const EmbedModal = ({ isOpen, onDismiss, embedType, embedId, embedCode }) => {
  const [isCodeCopied, setIsCodeCopied] = useState(false);

  const embedCodeDisplay =
    embedCode ??
    `<div class="strava-embed-placeholder" data-embed-type="${embedType}" data-embed-id="${embedId}"></div><script src="https://strava-embeds.com/embed.js"></script>`;

  function copyCode() {
    navigator.clipboard.writeText(embedCodeDisplay).then(() => {
      setIsCodeCopied(true);
      setTimeout(() => {
        setIsCodeCopied(false);
      }, 4000);
    });
  }

  return (
    <Modal
      isOpen={isOpen}
      onDismiss={onDismiss}
      hasClose={true}
      aria-labelledby="embed-modal-title"
      className={styles.embedModal}
    >
      <ModalTitle id="embed-modal-title">
        {I18n.t('templates.share.embed.get_code')}
      </ModalTitle>
      <ModalBody>
        <div className={styles.embedCodeContainer}>{embedCodeDisplay}</div>
      </ModalBody>
      <ModalActions>
        <Button onClick={onDismiss}>
          {I18n.t('components.button_cta_with_cancel.cancel')}
        </Button>
        <Button variant="primary" onClick={copyCode}>
          {isCodeCopied
            ? I18n.t('templates.share.embed.code_copied')
            : I18n.t('templates.share.embed.copy_code')}
        </Button>
      </ModalActions>
      <ModalBody className={styles.legalTerms}>
        <Markup
          content={I18n.t('templates.share.embed.by_embedding_html', {
            terms_path: 'https://www.strava.com/legal/api'
          })}
        />
      </ModalBody>
    </Modal>
  );
};

EmbedModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired,
  embedType: PropTypes.string.isRequired,
  embedId: PropTypes.string.isRequired,
  embedCode: PropTypes.string
};

EmbedModal.defaultProps = {
  embedCode: null
};

export default EmbedModal;
